// src/antdviews/AccountMgmtView.tsx
// 账户列表页面 - Ant Design 重构版（父容器）

import React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Layout } from 'antd'
import { checker } from '../utils/Checker'
import { ROLE } from '../services/Macro'
import { Page } from '../services/Page'
import Header from './components/Header'
import Sidebar from './components/Sidebar'
import AccountMgmtContent from './components/AccountMgmtContent'

const { Content } = Layout

interface AccountMgmtViewState {
    loginName: string
    isAuthorized: boolean
}

class AccountMgmtView extends React.Component<WithTranslation, AccountMgmtViewState> {

    constructor(props: WithTranslation) {
        super(props)
        this.state = {
            loginName: '',
            isAuthorized: false,
        }
        console.log(`进入账号管理页面时的登录校验`)
    }

    componentDidMount() {
        this.checkAuth()
    }

    checkAuth = async () => {
        const isLogin = await checker.checkLogin(ROLE.SUPER, Page.accountMgmt)
        if (isLogin) {
            this.setState({
                isAuthorized: true,
                loginName: localStorage.getItem('loginName') || 'Admin'
            })
        }
    }

    changeLang = () => { }

    render() {
        const { t, i18n } = this.props
        const { loginName, isAuthorized } = this.state

        return (
            <Layout style={{ minHeight: '100vh' }}>
                <Header
                    trans={t}
                    i18n={i18n}
                    loginName={loginName}
                    changeLang={this.changeLang}
                />
                <Layout>
                    <Sidebar selectMenu={Page.accountMgmt} trans={t} />
                    {isAuthorized ? (
                        <AccountMgmtContent />
                    ) : (
                        <Content style={{ margin: '4px', padding: '6px', background: '#f5f7fa', minHeight: '280px' }}>
                            {/* 未授权时显示空状态，checker.checkLogin 会处理跳转 */}
                        </Content>
                    )}
                </Layout>
            </Layout>
        )
    }
}

export const AccountMgmtPage = withTranslation()(AccountMgmtView)